/** @format */

import { Component, HostBinding, Input } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: `a[shared-totf-components-product-title]`,
	templateUrl: './product-title.component.html',
	styleUrl: './product-title.component.scss'
})
export class ProductTitleComponent {
	@HostBinding('attr.href') @Input() linkURL = '';
	@HostBinding('attr.data-em') @Input() dataEm = null;
	@HostBinding('attr.title') @Input() title = null;
	@HostBinding('attr.aria-label') @Input() ariaLabel = null;
}
